import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2wka1mua9h53u">
      <CountdownBar data-id="element-1" data-mp="2wj8dbo48im46" />
      <main data-id="element-2" data-mp="2wip734ny5m5z">
        <Hero data-id="element-3" data-mp="2wi5mthatqlos" />
        <StatsBar data-id="element-4" data-mp="28ufmg62gz4gf" />
        <Difference data-id="element-5" data-mp="28tw972nrl48q" />
        <Recognize data-id="element-6" data-mp="28t4lee0esat0" />
        <WhatsInside data-id="element-7" data-mp="28sl4n0mhvsgk" />
        <InstantAccess data-id="element-8" data-mp="28s30zixi6bym" />
        <Bonuses data-id="element-9" data-mp="23vupqgmff2wq" />
        <Offer data-id="element-10" data-mp="23u9uspw79hyc" />
        <Guarantee data-id="element-11" data-mp="23utbk3a460as" />
        <Testimonials data-id="element-12" data-mp="23t8fuac2cbbc" />
        <Faq data-id="element-13" data-mp="3ijxsv0nzqion" />
      </main>
      <Footer data-id="element-14" data-mp="3ikqytzf4l45q" />
    </div>;
}